var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c(
        _setup.FormSidebarBtn,
        {
          attrs: { disabled: _setup.isDisabled },
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _setup.onClick.apply(null, arguments)
            },
          },
        },
        [
          _c("span", {
            staticClass: "me-2",
            class: {
              "bi-square": !_setup.order.requestAReview,
              "bi-check-square": _setup.order.requestAReview,
            },
          }),
          _vm._v("\n    Request a review\n"),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }